import NewInstall from './NewInstall';
export default NewInstall;